import BeerFinderProduct from "./BeerFinderProduct";

import bestMatchImg from "../../assets/quiz/mood.png";
import safeChoiceImg from "../../assets/quiz/mood.png";
import discoveryImg from "../../assets/quiz/mood.png";

const RESULT_STEPS = [
  {
    id: "bestMatch",
    image: bestMatchImg,
    titleKey: "result_best_match",
    textKey: "result_best_match_desc",
  },
  {
    id: "safeChoice",
    image: safeChoiceImg,
    titleKey: "result_safe_choice",
    textKey: "result_safe_choice_desc",
  },
  {
    id: "discovery",
    image: discoveryImg,
    titleKey: "result_discovery",
    textKey: "result_discovery_desc",
  },
];

export default function BeerFinderResultScreen({
  t,
  mode,
  recommendations,
  answerTags,
  loadingRecommendations,
  error,
  onShowRecommendations,
  onRestart,
  onOpenProduct,
}) {
  const hasRecommendations =
    recommendations?.bestMatch ||
    recommendations?.safeChoice ||
    recommendations?.discovery;

  return (
    <div className="beerFinder">
      <div className="beerFinderResultCard">
        <h2 className="beerFinderResultTitle">
          {hasRecommendations ? t("result_products_title") : t("result_title")}
        </h2>

        {!hasRecommendations && answerTags?.length > 0 && (
          <div className="beerFinderProfile">
            {answerTags.map((tag) => (
              <span key={tag}>{tag}</span>
            ))}
          </div>
        )}

        {!hasRecommendations ? (
          <>
            <p className="beerFinderResultSubtitle">
              {t("result_subtitle")}
            </p>

            <div className="beerFinderResultIntro">
              {RESULT_STEPS.map((item) => (
                <div className="beerFinderResultIntroItem" key={item.id}>
                  <img src={item.image} alt={t(item.titleKey)} />

                  <div>
                    <h3>{t(item.titleKey)}</h3>
                    <p>{t(item.textKey)}</p>
                  </div>
                </div>
              ))}
            </div>

            <button
              className="beerFinderPrimaryBtn"
              type="button"
              onClick={onShowRecommendations}
              disabled={loadingRecommendations}
            >
              {loadingRecommendations ? (
                <span className="beerFinderLoadingDots">
                  <span></span>
                  <span></span>
                  <span></span>
                </span>
              ) : (
                t("result_select_beer")
              )}
            </button>
          </>
        ) : (
          <div className="beerFinderProductList">
            <BeerFinderProduct
              role={t("result_best_match")}
              text={t("result_best_match_desc")}
              product={recommendations.bestMatch}
              t={t}
              onOpenProduct={onOpenProduct}
            />

            <BeerFinderProduct
              role={t("result_safe_choice")}
              text={t("result_safe_choice_desc")}
              product={recommendations.safeChoice}
              t={t}
              onOpenProduct={onOpenProduct}
            />

            <BeerFinderProduct
              role={t("result_discovery")}
              text={t("result_discovery_desc")}
              product={recommendations.discovery}
              t={t}
              onOpenProduct={onOpenProduct}
            />
          </div>
        )}

        {error ? <p className="beerFinderError">{error}</p> : null}

        <button
          className="beerFinderGhostBtn"
          type="button"
          onClick={onRestart}
        >
          {mode === "saved" ? t("restart_saved") : t("restart")}
        </button>
      </div>
    </div>
  );
}